import './Contact.css';
import React, { Fragment } from "react"

import heroImg from '../images/bb_banner2.png'; 


function Contact() {
  return (
    <Fragment>
      <div className="contact-hero-section" style={{ backgroundImage: `url(${heroImg})` }}>
        <div className="contact-hero-overlay">
          <div className='contact-hero-container'>
            <h1>Get in Touch!</h1>
          </div>
        </div>
          
      </div>
      <div className="contact-page">
        <div className="contact-container">
          <h1 className="contact-title">Contact Information</h1>

          <div className="contact-item">
            <div className="contact-icon location-icon">📍</div>
            <div>
              <h2 className="contact-label">Location</h2>
              <p>Khadjia Market, Ahalia, Harimpur, Uttaria, Dhaka, Bangladesh</p>
            </div>
          </div>

          <div className="contact-item">
            <div className="contact-icon email-icon">✉️</div>
            <div>
              <h2 className="contact-label">Email</h2>
              <p>bbeschool2019@gmail.com</p>
            </div>
          </div>

          <div className="contact-item">
            <div className="contact-icon phone-icon">📞</div>
            <div>
              <h2 className="contact-label">Phone</h2>
              <p>+880 13 3514 1919</p>
            </div>
          </div>

        </div>
      </div>
    </Fragment>
    


  );
}

export default Contact;